import { DataTable } from './styles'

import HeaderCell from './HeaderCell'
import Pagination from './Pagination'
import Cell from './Cell'

DataTable.Cell = Cell
DataTable.HeaderCell = HeaderCell
DataTable.Pagination = Pagination

export default DataTable
